<template>
  <div class="header" :class="{'index': pageName=='Index'}">
    <div class="header-content">
      <img class="logo" :src="pageName=='Index' ? require('@/assets/logo-new.png') : require('@/assets/logo.jpg')">
      <ul class="menu-list">
        <li v-for="(menu, index) in menuList" :key="index">
          <a class="menu" :href="menu.path" target="_blank" rel="noopener noreferrer" v-if="menu.path.includes('http')">{{menu.content}}</a>
          <router-link class="menu" active-class="active" :to="menu.path" v-else>{{menu.content}}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { menuList } from '@/utils/data'
export default {
  name: 'pc-header',
  data() {
    return {
      pageName: '',
      menuList,
    }
  },
  mounted() {
    this.pageName = this.$route.name;
  },
  watch: {
    //监听路由
    $route() {
      this.pageName = this.$route.name;
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  width: 100%;
  background: #fff;
  .header-content{
    width: 1230px;
    height: 90px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo{
    height: 64px;
  }
  .menu-list{
    display: flex;
    align-items: center;
    height: 100%;
    li{
      height: 100%;
    }
  }
  .menu{
    height: 100%;
    display: flex;
    align-items: center;
    margin-right: 19px;
    position: relative;
    font-size: 16px;
    color: #000;
    &.active::after{
      content: '';
      display: block;
      width: 100%;
      height: 0;
      border-top: 1px solid #f33131;
      position: absolute;
      bottom: 20px;
      left: 0;
    }
  }
  &.index{
    position: absolute;
    top: 0;
    z-index: 999;
    .menu{
      color: #333333;
      &.active::after{
        display: none;
      }
    }
  }
}
</style>
